import React, { useEffect } from 'react';
import {
  CContainer,
  CButton,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import ShipmentStatusTable from '../../components/ShipmentStatusTable/ShipmentStatusTable';
import {
  getShipmentStatusRequestAction,
  sortShipmentStatusSortData,
  sortingShipmentStatusDataAction,
} from '../../store/shipmentStatus/shipmentStatusActions';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import './ShipmentStatus.scss';

const ShipmentStatus = ({
  shipmentStatusSortData,
  setSortData,
  sortingShipmentStatusData,
  shipmentStatusList,
  shipmentStatusData,
  getShipmentStatusRequest,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    getShipmentStatusRequest({});
  }, []);

  useEffect(() => {
    if (shipmentStatusSortData) {
      getShipmentStatusRequest({ ShipmentStatusId: null });
    }
  }, [shipmentStatusSortData]);

  const changeSortType = (sortType) => {
    const newSortData = { ...shipmentStatusSortData, sortType };
    setSortData(newSortData);
    sortingShipmentStatusData();
  };

  const changeSortKey = (sortKey) => {
    const newSortData = { ...shipmentStatusSortData, sortKey };
    setSortData(newSortData);
    sortingShipmentStatusData();
  };

  const handleCreateShipment = () => {
    navigate('/shipment-status/create');
  };

  return (
    <div className="shipment-status-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('Shipment Status')}</div>

        <ShipmentStatusTable
          changeSortType={changeSortType}
          changeSortKey={changeSortKey}
          sortData={shipmentStatusSortData}
          shipmentStatusList={shipmentStatusList}
          shipmentStatusData={shipmentStatusData}
        />
      </CContainer>

      <CButton
        color="primary"
        className="create-shipment-status-fab"
        onClick={handleCreateShipment}
        title={t('Create New Shipment')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

const mapStateToProps = (state) => ({
  shipmentStatusData: state.shipmentStatusReducer.shipmentStatusData,
  shipmentStatusList: state.shipmentStatusReducer.shipmentStatusList,
  shipmentStatusSortData: state.shipmentStatusReducer.shipmentStatusSortData,
  isLoading: state.loadingReducer.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  setSortData: (payload) => dispatch(sortShipmentStatusSortData(payload)),
  sortingShipmentStatusData: () => dispatch(sortingShipmentStatusDataAction()),
  getShipmentStatusRequest: (payload) => dispatch(getShipmentStatusRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentStatus);
